import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { CenterBrandingService } from '@core';
@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss'],
    imports: [LoadingBarModule, AsyncPipe]
})
export class PageLoaderComponent {
  private loadingBar = inject(LoadingBarService);
  private centerBrandingService = inject(CenterBrandingService);

  loadingValue$ = this.loadingBar.value$;
  branding$ = this.centerBrandingService.branding$;
}
